import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { provideHlmIconConfig } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-command-search',
  template: ` <ng-content /> `,
  host: {
    '[class]': '_computedClass()',
  },
  providers: [provideHlmIconConfig({ size: 'sm' })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HlmCommandSearch {
  /** The user defined class  */
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  /** The styles to apply  */
  protected readonly _computedClass = computed(() =>
    hlm('flex h-9 items-center gap-2 p-2 my-2 [&>_ng-icon]:flex-none [&>_ng-icon]:opacity-50', this.userClass()),
  );
}
